import React from 'react'
import Spinner from '../Spinner/spinner';
import { ToastContainer } from 'react-toastify';
import Pagination from '../Pagination/pagination';
import UseTimeZone from './Hooks/useTimeZone';

const TimeZone = () => {
    const {
        timeZoneData,
        spinner,
        page,
        PER_PAGE,
        count,
        setPage,
        setActive,
        changeStatus
    } = UseTimeZone()
    return (
        <>
            <ToastContainer />
            <section>
                <div className="m-t-3 cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            Time Zone
                        </h2>
                        <hr />
                    </header>
                    <p>Total Time Zone : {timeZoneData.totalCount}</p>
                    <div className='d-flex justify-content-end align-item-center'>
                        <div className='me-2'>
                            <select className='form-select me-2' name='status' onChange={(e) => setActive(e.target.value)}>
                                <option hidden>Status</option>
                                <option selected value={true}>Active</option>
                                <option value={false}>In-Active</option>
                            </select>
                        </div>
                    </div>
                    <table className="table  shadow mt-3">
                        <thead className="table-dark">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Code</th>
                                <th scope="col">Name</th>
                                <th scope="col">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                !timeZoneData.data?.length ? <div className='position-absolute top-10 end-50 mt-5'><h3>No record found</h3></div>
                                    :
                                    <>
                                        {
                                            timeZoneData?.data?.map((item, index) => {
                                                return <>
                                                    <tr>
                                                        <th scope="row">{PER_PAGE * (page - 1) + index + 1}</th>
                                                        <td key={index}>{item.text}</td>
                                                        <td>{item.name}</td>
                                                        <td>
                                                            <div className="form-check form-switch" style={{ marginLeft: '44%' }}>
                                                                <input className="form-check-input" role='switch' type="checkbox" checked={item.isActive} onChange={() => changeStatus(item)} />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </>
                                            })
                                        }
                                    </>
                            }
                        </tbody>
                    </table>
                    <div className='w-100 d-flex justify-content-center'>
                        {
                            count > 10 &&
                            <Pagination setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />
                        }
                    </div>
                </div>
            </section>
        </>
    )
}

export default TimeZone